import { useToast } from '@shared/hooks/use-toast';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePackingService } from './usePackingService';

export const usePrintOrder = () => {
    const { t } = useTranslation('packingModule');
    const { toast } = useToast();
    const [loadingOrders, setLoadingOrders] = useState<Set<number>>(new Set());
    const packingService = usePackingService();

    const printOrder = async (orderId: number, printerCode?: string) => {
        try {
            // Agregar el orderId al Set de pedidos en loading
            setLoadingOrders((prev) => new Set(prev).add(orderId));

            // Siempre usar PDF como método de impresión
            const printingMethod = 'pdf';

            console.log('🔍 usePrintOrder - Printing order:', {
                orderId,
                printingMethod,
                printerCode,
            });

            // Llamar a la API para imprimir
            const response = await packingService.adapter.printOrder(
                orderId,
                printingMethod,
                printerCode
            );

            console.log('🔍 usePrintOrder - Response:', response);

            // Verificar que la respuesta tenga el link
            // La respuesta puede venir como string directo, array o como objeto
            let linkUrl = null;

            if (typeof response === 'string') {
                // Si la respuesta ES directamente el string del link
                linkUrl = response;
            } else if (Array.isArray(response) && response.length > 0) {
                // Si es un array, tomar el primer elemento
                linkUrl = response[0];
            } else if (response && response.link) {
                // Si es un objeto con propiedad link
                linkUrl = response.link;
            }

            if (linkUrl) {
                // Mostrar toast de éxito ANTES de abrir la pestaña
                toast({
                    title: 'Etiqueta generada',
                    description: `La etiqueta del pedido se ha generado correctamente.`,
                    variant: 'default',
                });

                // Abrir en nueva pestaña
                window.open(linkUrl, '_blank');
            } else {
                throw new Error('No se recibió un link válido para la etiqueta');
            }
        } catch (error: any) {
            console.error('❌ usePrintOrder - Error printing order:', error);

            // Mostrar toast de error
            toast({
                title: 'Error al imprimir',
                description: error?.message || 'No se pudo generar la etiqueta del pedido',
                variant: 'destructive',
            });
        } finally {
            // Remover el orderId del Set de pedidos en loading
            setLoadingOrders((prev) => {
                const newSet = new Set(prev);
                newSet.delete(orderId);
                return newSet;
            });
        }
    };

    const isOrderLoading = (orderId: number) => loadingOrders.has(orderId);

    return {
        printOrder,
        isOrderLoading,
        loading: loadingOrders.size > 0,
    };
}; 